var map = {
	"./allinc.png": 580,
	"./allinclusive.png": 8982,
	"./alpereiser.png": 9539,
	"./amisol.png": 3952,
	"./apollo.png": 332,
	"./escapeaway.png": 6524,
	"./lionalpin.png": 6043,
	"./loveholidays.png": 7296,
	"./nazar.png": 2639,
	"./norwegianholidays.png": 5338,
	"./solfaktor.png": 5958,
	"./solia.png": 3381,
	"./soliadynamic.png": 876,
	"./test.png": 5635,
	"./ticket.png": 3663,
	"./tripx.png": 6030,
	"./tui.png": 5327,
	"./ving.png": 8649,
	"./vingdynamic.png": 5168,
	"./vitalreiser.png": 3861,
	"src/static/logo/supplier/66x22/allinc.png": 580,
	"src/static/logo/supplier/66x22/allinclusive.png": 8982,
	"src/static/logo/supplier/66x22/alpereiser.png": 9539,
	"src/static/logo/supplier/66x22/amisol.png": 3952,
	"src/static/logo/supplier/66x22/apollo.png": 332,
	"src/static/logo/supplier/66x22/escapeaway.png": 6524,
	"src/static/logo/supplier/66x22/lionalpin.png": 6043,
	"src/static/logo/supplier/66x22/loveholidays.png": 7296,
	"src/static/logo/supplier/66x22/nazar.png": 2639,
	"src/static/logo/supplier/66x22/norwegianholidays.png": 5338,
	"src/static/logo/supplier/66x22/solfaktor.png": 5958,
	"src/static/logo/supplier/66x22/solia.png": 3381,
	"src/static/logo/supplier/66x22/soliadynamic.png": 876,
	"src/static/logo/supplier/66x22/test.png": 5635,
	"src/static/logo/supplier/66x22/ticket.png": 3663,
	"src/static/logo/supplier/66x22/tripx.png": 6030,
	"src/static/logo/supplier/66x22/tui.png": 5327,
	"src/static/logo/supplier/66x22/ving.png": 8649,
	"src/static/logo/supplier/66x22/vingdynamic.png": 5168,
	"src/static/logo/supplier/66x22/vitalreiser.png": 3861
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2596;